import { deleteExternalServices } from '@/common/services/external-services.api';
import { useState } from 'react';

type Props = {
    id: string;
    onSubmit: () => void;
    onCancel: () => void;
};

export default function FormDeleteExternalServices({ id, onSubmit, onCancel }: Props) {
    const [loading, setLoading] = useState(false);
    const handleDelete = async () => {
        if (!id) {
            alert("ID inválido para exclusão.");
            return;
        }
        try {
            setLoading(true);
            const resp = await deleteExternalServices(id);
            if (!resp?.ok) {
                console.error("Falha ao excluir:", resp);
                alert(resp?.message || "Falha ao excluir o serviço externo.");
                return;
            }
            alert("Serviço externo cancelado com sucesso!");
            onSubmit(); 
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e: any) {
            console.error("Erro ao excluir:", e);
            alert(e?.message || "Erro inesperado ao excluir.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <p>Tem certeza que deseja cancelar este serviço externo?</p>
            <div className="flex gap-2 mt-4">
                <button
                    type="button"
                    className="px-4 py-2 bg-red-600 text-white rounded"
                    onClick={handleDelete}
                    disabled={loading}
                >
                    {loading ? "Excluindo..." : "Excluir"}
                </button>
                <button
                    type="button"
                    className="px-4 py-2 bg-gray-300 text-black rounded"
                    onClick={onCancel}
                    disabled={loading}
                >
                    Cancelar
                </button>
            </div>
        </div>
    );
}
